import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

// Focus and error change only the border color, no ring (guidebook p.77, Q10).
// autofill: browsers paint autofilled fields (Chrome: light blue, !important). A color transition
// that never finishes keeps the field's own background and text color.
const inputVariants = cva(
  "w-full min-w-0 border border-input bg-transparent transition-colors outline-none autofill:transition-[background-color,color] autofill:duration-100000000 file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50",
  {
    variants: {
      size: {
        default: "h-8 rounded-md px-2.5 py-1 text-base md:text-sm",
        // Fields share rounded-md (8px, Field/Default in Figma). Tixbase field: 48 tall, 16 / 12 side padding, type/web/body4 (Field/Default in Figma).
        lg: "h-12 rounded-md py-3 pr-3 pl-4 text-base md:text-body4",
      },
    },
    defaultVariants: {
      size: "default",
    },
  }
)

function Input({
  className,
  type,
  size = "default",
  ...props
}: Omit<React.ComponentProps<"input">, "size"> &
  VariantProps<typeof inputVariants>) {
  return (
    <input
      type={type}
      data-slot="input"
      data-size={size}
      className={cn(inputVariants({ size, className }))}
      {...props}
    />
  )
}

export { Input, inputVariants }
